/*
 * Types.
 */

export enum ModifiersEnum {
  INBOX = 'inbox',
  TOPIC = 'topic',
  LINK = 'link',
  RECIPIENT = 'recipient',
  FROM = 'from',
  TO = 'to',
  CC = 'cc',
  BCC = 'bcc',
  SUBJECT = 'subject',
  BODY = 'body',
  ASSIGNEE = 'assignee',
  AUTHOR = 'author',
  MENTION = 'mention',
  COMMENTER = 'commenter',
  PARTICIPANT = 'participant',
  TYPE = 'type',
  TAG = 'tag',
  ACCOUNT = 'account',
  HAS = 'has',
  IS = 'is',
  IN = 'in',
  BEFORE = 'before',
  AFTER = 'after',
  DURING = 'during',
  ID = 'id',
}
